module.exports = __webpack_public_path__ + "img/ch.c5973ba2.svg";